module.exports = __webpack_public_path__ + "img/paradox-logo.660f4695.png";